import { mutateApi, queryApi } from "src/utils/api/ApiMethods"
import { arrayToUrlQueryString } from "src/utils/api/query_param_helpers"
import { camelCaseToSnakecase } from "src/utils/string_helpers"
import { getCurrentMarinaSlug } from "src/utils/url/parsing/marina"

export const requestIntegration = (data) => {
  const marinaSlug = getCurrentMarinaSlug()
  return mutateApi({
    url: `/manage/${marinaSlug}/marketplace/request_integration`,
    method: "POST",
    data: { requested_integration: data },
  })
}

export const queryMappableDockwaProducts = ({
  marinaSlug,
  filters,
  pageSize,
}) => {
  const {
    categories,
    failedSyncs,
    page,
    searchTerm,
    sortDirection,
    sortKey,
    status,
  } = filters
  const paramsObj = {}

  if (searchTerm) {
    paramsObj.search_term = searchTerm
  }

  if (sortDirection) {
    paramsObj.sort_key = sortKey ? camelCaseToSnakecase(sortKey) : null
    paramsObj.sort_direction = sortDirection
  }

  if (status) {
    paramsObj.status = status
  }

  if (typeof failedSyncs === "boolean") {
    paramsObj.failed_syncs = failedSyncs
  }

  paramsObj.page = page
  paramsObj.page_size = pageSize

  const categoriesQuery = arrayToUrlQueryString({
    queryParam: "categories",
    values: categories,
  })

  const urlParams = new URLSearchParams(paramsObj)
  const url = `/manage/${marinaSlug}/integrations/products?${urlParams.toString()}${categoriesQuery}`

  return queryApi(url, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
}
